import { render, staticRenderFns } from "./chbProductDetails.vue?vue&type=template&id=09424729&scoped=true"
import script from "./chbProductDetails.vue?vue&type=script&lang=js"
export * from "./chbProductDetails.vue?vue&type=script&lang=js"
import style0 from "./chbProductDetails.vue?vue&type=style&index=0&id=09424729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09424729",
  null
  
)

export default component.exports